<!-- 【前台首页】 -->
<template>
  <div class="front-body">
    <el-card class="box-card" style="min-height: 800px">
    <div slot="header" class="clearfix">
      <sui-breadcrumb></sui-breadcrumb>
    </div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>{{item.title}}</span>
        </div>
        <div v-html="item.content"></div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>联系方式</span>
        </div>
          <ul style="height: 100px;margin-top: -20px">
            <li style="float:left;margin: 30px;">
              <img style="width:150px;height:150px" src="https://suifeng.info/attach_files/upload/media/2022/11/08/1589808977276256257.jpg" title="微信扫一扫"/>
              <div style="text-align: center;font-weight: bold;font-family: cursive;">公众号二维码</div>
            </li>
            <li style="float:left;margin: 30px;">
              <img style="width:150px;height:150px" src="https://suifeng.info/attach_files/upload/media/2022/11/08/1589812867119923202.jpg" title="微信扫一扫"/>
              <div style="text-align: center;font-weight: bold;font-family: cursive;">我的微信</div>
            </li>
            <li style="float:left;margin: 30px;">
              <img style="width:150px;height:150px" src="https://suifeng.info/attach_files/upload/media/2022/11/08/1589812085402320897.jpg" title="淘宝App扫一扫"/>
              <div style="text-align: center;font-weight: bold;font-family: cursive;">淘宝App扫一扫</div>
            </li>
          </ul>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>商品链接</span>
        </div>
        <el-carousel style="text-align: center" type="card" height="250px">
          <el-carousel-item v-for="item in dataList" :key="item">
            <a :href="item.href" target="_blank">
              <el-image style="width: 150px;height: 150px;border-radius: 5px" :src="formatUrl(item.picture)"></el-image>
              <h3 class="medium" style="font-family: cursive">{{item.title }}</h3>
            </a>
          </el-carousel-item>
        </el-carousel>
      </el-card>
    </el-card>
    <el-backtop target=".front-page" :bottom="100" :visibility-height="50"></el-backtop>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        item: {},
        dataList: {},
        total:0,
        queryForm: {
          current: 1,
          size: 8,
          id: "",
          picture: "",
          title: "",
          name: "",
          categoryId: "",
          content: ""
        },
      }
    },
    computed: {},
    mounted(){
      //初始化数据
      this.getList();
    },
    methods: {
      //点击搜索
      handleQuery() {
        this.queryForm.current = 1;
        this.getList();
      },
      //查询列表数据
      getList() {
        const loading = this.$loading({
          lock: true,
          text: '请稍后,加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0,0,0,0.25)'
        });
        this.$request.doGet('/api/item/getPage?itemType=6').then(res => {
          if (res.isOk) {
            this.item = res.obj.records[res.obj.records.length-1];
            this.dataList=res.obj.records.splice(0,res.obj.records.length-1);
            console.log(this.dataList)
            loading.close();
          }
        });
      },
      //重置查询
      resetQuery() {
        this.$refs['queryForm'].resetFields();
        this.handleQuery();
      },
      //选择页码
      handleCurrentChange: function (currentPage) {
        this.queryForm.current = currentPage;
        this.getList();
      },
    }
  }
</script>
<style scoped>
  .wheel-picture {
    height: 100%;
    width: 100%;
    border-radius: 5px
  }
  .shadow_font{
    text-shadow: grey 1px 1px 1px;
  }
  .shadow_li{
    text-shadow: ghostwhite 1px 1px 1px;
  }
  .shop{
    float:left;
    margin: 30px;
    color:rgb(214, 8, 8)
  }
  .shop a{
    color: rgb(214, 8, 8)
  }
  .doc{
    height: 150px;color: #137cc2;
  }
  .doc a{
    color: #137cc2;
  }
  ul{
    list-style-type :none
  }
  .li-down{
    font-weight: bold;
    color: white;
    background-repeat: no-repeat;
    background-size: 30px 30px;
    background-position-x: 60px;
    background-position-y: 15px;
    border-radius: 10px;
    text-align: center;
    width: 150px;
    height: 90px;
    background-color: #00a2d4;
    float: left;
    margin: 10px;
    line-height: 130px;
  }
  .li-down:hover{
    background-color: rgba(0, 162, 212, 0.8);
  }
  .money{
    width: 300px;
    height: 300px;
    background-image: url("${ctxStatic}/images/admire/money.jpg");
    background-repeat: no-repeat;
    background-size: 300px 300px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/front/service/item/about.vue